/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Check_OutInputs */



/**
* | output |
* | --- |
* | "Check out" |
*
* @param {Players_Check_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_check_out = /** @type {((inputs?: Players_Check_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Check_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dépointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Check-out")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-out")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check out")
	return /** @type {LocalizedString} */ ("Check out")
});